"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlansOrder_1 = __importDefault(require("@CommonFrontendBackend/Utils/PlansOrder"));
var UpsellerService = (function () {
    function UpsellerService($http, apiBaseUrl, planService) {
        this.$http = $http;
        this.apiBaseUrl = apiBaseUrl;
        this.planService = planService;
        this.getTooltipUpsellMessage = this.getTooltipUpsellMessage.bind(this);
    }
    UpsellerService.prototype.getPlanNameForFeature = function (featureName) {
        return __awaiter(this, void 0, Promise, function () {
            var _a, $http, apiBaseUrl, response, plan;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!featureName) {
                            throw new Error("No feature given");
                        }
                        _a = this, $http = _a.$http, apiBaseUrl = _a.apiBaseUrl;
                        return [4, $http.get("".concat(apiBaseUrl, "/plans/feature/").concat(featureName)).catch(function (err) {
                                if (err.status === -1) {
                                    throw new Error("Could not connect to server");
                                }
                                else {
                                    throw err;
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        plan = response.data.message[0];
                        if (plan != null) {
                            return [2, plan.displayName];
                        }
                        else {
                            return [2, null];
                        }
                        return [2];
                }
            });
        });
    };
    UpsellerService.prototype.getTooltipUpsellMessage = function (featureName) {
        return __awaiter(this, void 0, Promise, function () {
            var featurePlan;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPlanNameForFeature(featureName)];
                    case 1:
                        featurePlan = _a.sent();
                        return [2, "Upgrade to the ".concat(featurePlan, " plan to use this feature")];
                }
            });
        });
    };
    UpsellerService.prototype.getPlanNameForSeatCount = function (seatCount) {
        return __awaiter(this, void 0, Promise, function () {
            var PLAN_NAMES, plans, _loop_1, PLAN_NAMES_1, PLAN_NAMES_1_1, planName, state_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        PLAN_NAMES = (0, PlansOrder_1.default)();
                        return [4, this.planService.fetchPlans()];
                    case 1:
                        plans = _b.sent();
                        _loop_1 = function (planName) {
                            var plan = plans.find(function (p) {
                                return p.displayName === planName;
                            });
                            var maxSeats = plan.seats.max || Infinity;
                            if (maxSeats >= seatCount) {
                                return { value: planName };
                            }
                        };
                        try {
                            for (PLAN_NAMES_1 = __values(PLAN_NAMES), PLAN_NAMES_1_1 = PLAN_NAMES_1.next(); !PLAN_NAMES_1_1.done; PLAN_NAMES_1_1 = PLAN_NAMES_1.next()) {
                                planName = PLAN_NAMES_1_1.value;
                                state_1 = _loop_1(planName);
                                if (typeof state_1 === "object")
                                    return [2, state_1.value];
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (PLAN_NAMES_1_1 && !PLAN_NAMES_1_1.done && (_a = PLAN_NAMES_1.return)) _a.call(PLAN_NAMES_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2, null];
                }
            });
        });
    };
    UpsellerService.prototype.getPlanNameForUpgrade = function (currentPlan) {
        switch (currentPlan.displayName) {
            case "Free":
            case "Trial":
            case "Pro":
                return "Business";
            case "Business":
                return "Enterprise";
            default:
                return null;
        }
    };
    return UpsellerService;
}());
exports.default = UpsellerService;
